import { MakePaths } from "common/router/types";
import { MakeRoutesOpts } from "common/router/utils/routes";
import { makeUrls } from "common/router/utils/urls";

import { makeClientRoutes } from "client/routes/types";

import { DosageRemindersPageSearch } from "../types";

const paths = {
  list: "/",
};

type DosageReminderPathDefinitions = {
  list: { Search: DosageRemindersPageSearch };
};

export type DosageReminderPaths = MakePaths<DosageReminderPathDefinitions>;

export const useDosageReminderRoutes = (opts: MakeRoutesOpts) => {
  return makeClientRoutes(opts, [
    {
      path: paths.list,
      element: () => import("../components/DosageRemindersPage"),
      pageName: "reminders",
    },
  ]);
};

export const makeDosageReminderUrls = (base: string) => {
  return makeUrls<DosageReminderPathDefinitions>(base, {
    list: { path: paths.list },
  });
};
